var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header1"},[_c('div',{staticClass:"header1-section"},[_vm._v("Logo")]),_c('div',{staticClass:"header1-section"},[_c('custom-select')],1),_c('div',{staticClass:"header1-section"},[_c('search-input')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }